import { useEffect, useState } from "react";
import axios from "axios";
import { UPLOAD_ENDPOINT } from "../../constants";
import useSocket from "useSocket";


const DEMO_MEDIAMAP = {
  loud: "loud_demo",
  mix: "mix",
  stream: "stream_demo"
}

function useLandingPage() {
  const [stage, setStage] = useState(-1);
  const [progress, setProgress] = useState(0);
  const [completedSize, setCompletedSize] = useState(0);
  const [totalSize, setTotalSize] = useState(0);
  const [fileName, setFileName] = useState("");
  const [error, setError] = useState("");
  const [projectID, setProjectID] = useState("");
  const { progress: stepProgress, stepId, isDone } = useSocket(projectID);

  const handleUpload = async (file: any) => {
    setError(""); // Reset error
    const sizeInMb = Number((file.size / (1024 * 1024)).toFixed(2));
    setFileName(file.name);
    setTotalSize(sizeInMb);
    setStage(0); // Stage 0: Upload Started
    const formData = new FormData();
    formData.append("file", file);
    formData.append("fileName", file.name);
    formData.append("fileSize", file.size);

    try {
      const resp = await axios.post(UPLOAD_ENDPOINT, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        onUploadProgress: (progressEvent: any) => {
          const uploadedBytes = progressEvent.loaded;
          const totalBytes = progressEvent.total || file.size;
          const completedMb = Number(
            (uploadedBytes / (1024 * 1024)).toFixed(2)
          );
          const uploadProgress = Math.round((uploadedBytes / totalBytes) * 100);
          setCompletedSize(completedMb);
          setProgress(uploadProgress);
        },
      });

      if (resp.data.success) {
        const respProjectID = resp.data.projID;
        setProjectID(respProjectID);
      }
    } catch (error) {
      console.error("Upload failed:", error);
      setError("Oops! Something went wrong with the upload. Please try again.");
      setStage(-1); // Stage -1: Upload Failed
    }
  };

  useEffect(() => {
    if(!isDone) return;
    //make a api call to 
  }, [isDone])


  return {
    handlers: {
      handleUpload,
    },
    data: {
      progressStagesProps: {
        stage: stepId || stage, // Use stepId when available
        progress: stepProgress !== null ? stepProgress : progress, // Prioritize stepProgress
        completedSize,
        totalSize,
        fileName,
        stepProgress,
        stepId,
      },
      isDone,
      error,
      projectID
    },
  };
}

export default useLandingPage;
